import { version } from '../../../package.json';

export const ROOT_API = import.meta.env.VITE_ROOT_API;
export const SOCKET_URL = import.meta.env.VITE_SOCKET_URL;
export const APP_DOMAIN = import.meta.env.VITE_DOMAIN;
export const IDLE_TIMER = Number(import.meta.env.VITE_IDLE_TIMER);
export const CORE_VERSION = import.meta.env.VITE_VERSION ?? version ?? '';
export const UPLOAD_SERVICE_API = import.meta.env.VITE_UPLOAD_SERVICE_URL;
export const DELINQUENCY_API = import.meta.env.VITE_DELINQUENCY_API;
export const DELINQUENCY_SOCKET = import.meta.env.VITE_DELINQUENCY_SOCKET;
export const LOAN_PRO_API = import.meta.env.VITE_LOAN_PRO_API;
export const DOC_PRO_ROOT_API = import.meta.env.VITE_DOC_PRO_API;

//logging and performance env
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_TRACES_SAMPLE_RATE =
  import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || 80;
export const SENTRY_REPLAY_SESSION_SAMPLE_RATE =
  import.meta.env.VITE_SENTRY_REPLAY_SESSION_SAMPLE_RATE || 0.1;
export const SENTRY_REPLAY_ONERROR_SAMPLE_RATE =
  import.meta.env.VITE_SENTRY_REPLAY_ONERROR_SAMPLE_RATE || 1;
